import './account/scripts';
import './orders/scripts';
import './klubSidebar/scripts'